import { ContainerItemStore } from '@planning/rt-stores/container/ContainerItemStore'
import { ContainerTurnoverInternalQueryResult, containerTurnoverService } from '@tom-ui/integration'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'

export class ContainerHistoryViewStore {
  containerId?: number
  containerTurnoverList: ContainerTurnoverInternalQueryResult[] = []

  constructor(private readonly containerItemStore: ContainerItemStore) {
    makeObservable(this, {
      containerId: observable,
      containerTurnoverList: observable,

      container: computed,

      setContainerId: action,
    })
  }

  get container() {
    return this.containerId ? this.containerItemStore.elements[this.containerId] : undefined
  }

  setContainerId = (containerId?: number) => (this.containerId = containerId)

  fetch = async (containerId: number) => {
    this.setContainerId(containerId)

    await this.containerItemStore.fetchById(containerId)

    const containerTurnovers = await containerTurnoverService.getByFilter(containerId)

    runInAction(() => {
      this.containerTurnoverList = containerTurnovers
    })
  }
}
